import { render } from "./vesting.vue?vue&type=template&id=371cbd79&scoped=true"
import script from "./vesting.vue?vue&type=script&lang=ts"
export * from "./vesting.vue?vue&type=script&lang=ts"

import "./vesting.vue?vue&type=style&index=0&id=371cbd79&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-371cbd79"

export default script